/** @format */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxFudisModule } from '@funidata/ngx-fudis';
import { UIRouterModule } from '@uirouter/angular';
import { SisCommonModule } from 'sis-common';
import { SisComponentsModule } from 'sis-components';
import { StudentCommonModule } from '../common/common.module';
import { SelectCourseUnitsModalComponent } from './select-course-units-modal/select-course-units-modal.component';
import { ShowPastStudyTermsCheckboxComponent } from './show-past-study-terms/show-past-study-terms-checkbox.component';
import { ShowSummerPeriodCheckboxComponent } from './summer-period-checkbox/show-summer-period-checkbox.component';
import { TimeCourseUnitModalComponent } from './time-course-unit-modal/time-course-unit-modal.component';
import { HorizontalTimelineComponent } from './timeline/horizontal-timeline/horizontal-timeline.component';
import { TimelineCourseUnitComponent } from './timeline/timeline-study-term/timeline-study-period/timeline-course-unit/timeline-course-unit.component';
import { TimelineCustomCourseUnitAttainmentComponent } from './timeline/timeline-study-term/timeline-study-period/timeline-custom-course-unit-attainment/timeline-custom-course-unit-attainment.component';
import { TimelineCustomStudyDraftComponent } from './timeline/timeline-study-term/timeline-study-period/timeline-custom-study-draft/timeline-custom-study-draft.component';
import { TimelineMultiPeriodTimingNotificationBoxComponent } from './timeline/timeline-study-term/timeline-study-period/timeline-multi-period-timing-notification-box/timeline-multi-period-timing-notification-box.component';
import { TimelineStudyPeriodComponent } from './timeline/timeline-study-term/timeline-study-period/timeline-study-period.component';
import { TimelineStudyTermComponent } from './timeline/timeline-study-term/timeline-study-term.component';
import { TimelineComponent } from './timeline/timeline.component';
import { TimingPlanSelectComponent } from './timing-plan-select/timing-plan-select.component';
import { ModuleTimingTemplateComponent } from './timing-template/module-timing-template/module-timing-template.component';
import { TimingTemplateModalComponent } from './timing-template/timing-template-modal/timing-template-modal.component';
import { TimingComponent } from './timing.component';
import { states } from './timing.route';
import { TotalCreditsComponent } from './total-credits/total-credits.component';

@NgModule({
    declarations: [
        TimingComponent,
        TimelineComponent,
        HorizontalTimelineComponent,
        TimelineCourseUnitComponent,
        TimelineCustomCourseUnitAttainmentComponent,
        TimelineCustomStudyDraftComponent,
        ShowPastStudyTermsCheckboxComponent,
        ShowSummerPeriodCheckboxComponent,
        ModuleTimingTemplateComponent,
        TimelineStudyPeriodComponent,
        TimelineStudyTermComponent,
        TimelineStudyPeriodComponent,
        TimingTemplateModalComponent,
        SelectCourseUnitsModalComponent,
        TimeCourseUnitModalComponent,
        TimingPlanSelectComponent,
        TimelineMultiPeriodTimingNotificationBoxComponent,
        TotalCreditsComponent,
    ],
    // prettier-ignore
    imports: [
        CommonModule,
        NgxFudisModule,
        SisCommonModule,
        SisComponentsModule,
        UIRouterModule.forChild({ states }),
        StudentCommonModule,
    ],
})
export class TimingModule {}
